/**
 * Límites de captura del módulo Matriz de Riesgos IA.
 *
 * NO son valores elegidos a ojo: salen de information_schema de la base. Cada
 * número es el largo real de su columna.
 *
 * Por qué importa: producción corre con sql_mode = STRICT_TRANS_TABLES. Un
 * texto más largo que su columna NO se trunca, ABORTA la sentencia — el
 * usuario ve "no se pudo guardar" sin saber por qué. Con el maxlength puesto,
 * el navegador no lo deja llegar a ese punto.
 *
 * Las columnas TEXT admiten 65,535 BYTES, no caracteres, y un acento ocupa
 * dos. Se usan 16,000 caracteres: sobra para cualquier captura real —la
 * descripción más larga del documento tiene 2,785— y es segura aun si cada
 * carácter ocupara los 4 bytes máximos de utf8mb4.
 */
export const TEXTO_LARGO = 16000;

export const LIMITES = {
  /** iso42001_matriz_activo */
  activo: {
    nombreActivo: 200,
    tipoActivo: 50,
    justificacionValoracion: TEXTO_LARGO,
    activosDependientes: TEXTO_LARGO,
  },

  /** iso42001_matriz_amenaza */
  amenaza: {
    nombreAmenaza: 500,
  },

  /** iso42001_matriz_vulnerabilidad */
  vulnerabilidad: {
    nombreVulnerabilidad: 500,
  },

  /** iso42001_matriz_accion */
  accion: {
    descripcion: TEXTO_LARGO,
    estado: 20,
    responsable: 300,
    prioridad: 20,
    recursos: TEXTO_LARGO,
  },

  /** iso42001_matriz_seguimiento y iso42001_riesgo_proceso_seguimiento */
  corte: {
    resultado: TEXTO_LARGO,
  },

  /** iso42001_riesgo_proceso */
  riesgo: {
    faseDeteccion: 60,
    descripcion: TEXTO_LARGO,
    causaRaiz: TEXTO_LARGO,
    estrategia: 30,
    periodicidad: 40,
    acciones: TEXTO_LARGO,
    responsableRecursos: TEXTO_LARGO,
    activosRelacionados: 300,
  },

  /** iso42001_matriz_version */
  version: {
    version: 10,
    descripcion: TEXTO_LARGO,
    elaboro: 200,
    autorizo: 200,
  },
};

/**
 * Campos obligatorios, tomados de las columnas NOT NULL sin valor por omisión.
 * Se listan para que la pantalla marque lo mismo que exige la base y no haya
 * un formulario que deje guardar algo que el backend va a rechazar.
 */
export const OBLIGATORIOS = {
  activo: ["nombreActivo"],
  amenaza: ["nombreAmenaza"],
  vulnerabilidad: ["nombreVulnerabilidad"],
  accion: ["descripcion"],
  corte: ["fechaMonitoreo", "resultado"],
  riesgo: ["descripcion"],
  version: ["version", "descripcion", "elaboro", "autorizo", "fechaVersion"],
};
